<template>
  <div>
    <p>
      The inter-plane phasing is the angular separation between two spacecrafts
      of two consecutive planes. It is represented on the figure below by the
      angle <katex-element expression="\phi_\text{inter}" />.
      <br />
      <br />
      If no value is provided for the simulation, this value will be determined
      automatically in order to minimise the mean revisit rate at the equator.
      <br />
      <br />
      <v-img
        contain
        :src="require('../../../assets/images/tooltip-inter-plane-phasing.png')"
        aspect-ratio="1.8"
      />
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipConstellationGeometryInterplanePhasing'
}
</script>
